import React, {useEffect, useState} from 'react';
import {RiFilter3Fill} from "react-icons/ri"
import {useNavigate, useSearchParams} from "react-router-dom";
import {Dropdown, Space} from "antd";
import {useSelector} from "react-redux";

const FilterWeightStation = props => {

    const navigate = useNavigate()

    const [searchParams] = useSearchParams()
    const tabKey = searchParams.get("weightStation")
    const [name , setName] = useState()
    const {weighingStation} = useSelector(state => state.permissionAccountActionReducer)

    const tabItems2 = ()=>{
        if (!weighingStation || weighingStation?.length === 0) {
            return [];
        }

        const defaultItems = [
            { type: 'divider' },
            {
                label: 'Xóa các lựa chọn',
                key: 'deleteAllSelection',
                disabled: !tabKey
            },
        ]

        let data = []
        weighingStation?.map(item=>{
            data.push({
                key: item.weighingStationCode,
                label: item.weighingStationName,
            })
        })
        return data.concat(defaultItems)
    }

    const [filterData, setFilterData] = useState([])

    useEffect(()=>{
        setFilterData(tabItems2())
        setName(mapName())
    },[weighingStation])

    useEffect(() => {
        if (filterData.length > 0 ){
            setFilterData(filterData?.map(item => {

                const disabled = !tabKey && item.key === "deleteAllSelection"

                if (item.key === "deleteAllSelection") {
                    item.label = <span style={{color: disabled ? "#344054" : "#007FFF"}}>
                    Xóa các lựa chọn
                </span>
                }

                return {
                    ...item,
                    disabled
                }
            }))
        }
        setName(mapName())
    }, [tabKey, weighingStation])

    const onChangeTab = (tab) => {
        const key = tab.key

        if (key === "deleteAllSelection") {
            searchParams.delete("weightStation")
        } else {
            searchParams.set("weightStation", key);
        }
        navigate(`?${searchParams.toString()}`)

    }

    const mapName = () =>{
        const filter = weighingStation?.filter(item=> item.weighingStationCode === searchParams.get("weightStation") )
        return filter[0]?.weighingStationName
    }

    return (
        <Dropdown
            menu={{
                items: filterData,
                onClick: onChangeTab,
                selectedKeys: searchParams.get("weightStation"),
                className: "extraMenuFilter"
            }}
            trigger={['click']}
        >
            <Space className={"cursor-pointer customer_space"}>
                <span style={{color: "#344054"}}>
                    {searchParams.get("weightStation") && (
                        <>
                            <span className={"text-lg font-medium"}> {" / "} {name}</span>
                        </>
                    )}
                </span>
                <RiFilter3Fill style={{fontSize: 15}}/>
            </Space>
        </Dropdown>
    );
};

FilterWeightStation.propTypes = {};

export default FilterWeightStation;
